module.exports = __webpack_public_path__ + "static/media/SizeBadOptimized.0471a463.png";